import { Link } from 'react-router-dom';

/**
 * Cuentas, Tarjetas y Meses sin intereses son TRES PESTAÑAS DE UN MISMO DESTINO
 * (RF-042, RF-077, D-62): el módulo registra UNA SOLA sección en el shell y ni el
 * 2/6 ni el 4/6 reclaman un segundo lugar en la barra inferior.
 *
 * LA TERCERA PESTAÑA ES LA DEL 4/6 y así cierra la pregunta que el 2/6 dejó
 * abierta en RF-042 —"el módulo 4/6 no registra un destino propio en la barra o
 * desplaza a otro al menú; lo resuelve el 4/6 en su análisis"—: NO LE QUITA EL
 * LUGAR A NADIE. La barra sigue teniendo seis lugares y el sexto es de Ajustes
 * (RN-044b, RN-044c).
 */
export function PestanasDeCuentas({ activa }) {
  return (
    <div style={{ display: 'flex', background: 'var(--card)', borderBottom: '1px solid var(--bor)' }}>
      <Link
        to="/cuentas"
        aria-current={activa === 'cuentas' ? 'page' : undefined}
        style={estilo(activa === 'cuentas')}
      >
        Cuentas
      </Link>
      <Link
        to="/cuentas/tarjetas"
        aria-current={activa === 'tarjetas' ? 'page' : undefined}
        style={estilo(activa === 'tarjetas')}
      >
        Tarjetas
      </Link>
      <Link
        to="/cuentas/meses"
        aria-current={activa === 'meses' ? 'page' : undefined}
        style={estilo(activa === 'meses')}
      >
        Meses sin intereses
      </Link>
    </div>
  );
}

function estilo(encendida) {
  return {
    flex: 1,
    minHeight: 46,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    textDecoration: 'none',
    color: encendida ? 'var(--act)' : 'var(--sec)',
    fontWeight: encendida ? 700 : 400,
    boxShadow: encendida ? 'inset 0 -3px 0 var(--act)' : undefined,
  };
}
